import Layout from "./Layout";

export default Layout;
export { LayoutVariant } from "./Layout.types";
